import { Tab as HeadlessTab } from '@coveo/headless';
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { useCurrentVideoStore } from 'src/helpers/VideoGalleryHelpers/VideoListing.store';

type CoveoTabProps = PropsWithChildren<React.ReactNode | React.ReactNode[]> & {
  controller: HeadlessTab;
  classes: {
    tabButton: string;
  };
};

export const CoveoTab = (props: CoveoTabProps) => {
  const { controller, classes } = props;
  const [state, setState] = useState(controller.state);
  const { setTabClicked } = useCurrentVideoStore();

  useEffect(() => controller.subscribe(() => setState(controller.state)), [controller]);

  const handleClick = () => {
    controller.select();
    setTabClicked(true);
  };

  return (
    <button className={classes.tabButton} disabled={state.isActive} onClick={handleClick}>
      {props.children}
    </button>
  );
};
